<template>
    <!--Wrapper - Outer-->
    <div class="wrapper outer">
        <div class="wrapper inner">
            <!--Sidebar - Primary-->

            <div class="sidebar primary" id="dvSidebarPrimary">
                <!--Header Section-->

                <PrimarySidebar />
            </div>


            <div class="page">

                <div class="content">

                    <ModalGeneric />

                    <ModalUser />
                    <!--Tela Principal-->

                    <div class="tela-principal">
                        <div
                            class="page-wrapper primary"
                            id="dvPageWrapperPrimary"
                        >
                            <!--Page Body - Primary-->

                            <section class="section page-body primary special">
                                <div class="page-body-wrapper primary">
                                    <!--Navbar - Primary-->

                                    <Toolbar />
                                    <!--Wizard-->

                                    <!--Crew List -->
                                    <div class="wizard">
                                        <!--Command List - Primary-->

                                        <section
                                            class="section command-list primary"
                                        >
                                            <!--Header Section-->

                                            <div class="command-list-header" v-if="!hasMessage && historyMessages.length == 0">
                                                <div class="header-image">
                                                    <div class="image">
                                                        <img
                                                            src="/assets/images/logo/logo-escolarai-b.svg"
                                                        />
                                                    </div>
                                                </div>
                                                <div class="header-text">
                                                    <div class="title">
                                                        <h2>
                                                            Como posso lhe
                                                            ajudar hoje?
                                                        </h2>
                                                    </div>
                                                </div>
                                            </div>

                                            <!--Content Section-->

                                            <div
                                                class="command-list-content"
                                                v-if="!hasMessage && historyMessages.length == 0"
                                            >
                                                <div class="row">
                                                    <div
                                                        class="col-content-outer"
                                                    >
                                                        <div class="row">
                                                            <div
                                                                class="col-content-inner"
                                                                v-for="crew in crews"
                                                                :key="crew.id"
                                                            >
                                                                <div
                                                                    class="content-wrapper primary"
                                                                    @click="getParameters(crew.id, crew)"
                                                                >
                                                                    <a
                                                                        class="content-anchor"
                                                                    ></a>
                                                                    <div
                                                                        class="content-image"
                                                                    >
                                                                        <div
                                                                            class="image"
                                                                        >
                                                                            <img
                                                                                src="/assets/images/root/command-list-primary-content-icon-1.svg"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="content-text"
                                                                    >
                                                                        <div
                                                                            class="title"
                                                                        >
                                                                            <h3>
                                                                                {{
                                                                                crew.name
                                                                                }}
                                                                            </h3>
                                                                        </div>
                                                                        <div
                                                                            class="desc"
                                                                        >
                                                                            <p>
                                                                                {{
                                                                                crew.description
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!--Message Conversation List -->
                                            
                                        <section class="section message-list primary" v-if="historyMessages.length != 0" ref="messageList">

                                            <!--Content Section-->

                                            <div class="message-list-content">
                                                <div class="content-wrapper primary">
                                                    <div v-for="(message, index) in historyMessages" :key="index">
                                                        <div class="wrapper-inner asking">
                                                            <div class="content-text">
                                                                <div class="desc">
                                                                    <p>{{ message.content }}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="wrapper-inner answer">
                                                            <div class="content-icon">
                                                                <div class="icon">
                                                                    <img src="assets/images/logo/logo-escolarai-b.svg" />
                                                                </div>
                                                                <div class="value-text">
                                                                    <div class="title">
                                                                        <h3>Chat de Dúvidas</h3>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="content-value">
                                                             
                                                                <div class="value-caption">
                                                                    <div class="caption">
                                                                        <span v-html="responseRunIa[index]?.title"></span>
                                                                    </div>
                                                                </div>
                                                                <div class="value-text">
                                                                    <p v-html="responseRunIa[index]?.output"></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="loading-dots" v-if="showLoading">
                                                <div class="loading-dots-content">
                                                    <span class="dot"></span>
                                                    <span class="dot"></span>
                                                    <span class="dot"></span>
                                                </div>
                                            </div>
                                        </section>
                                        </section>
                                    </div>
                                </div>
                            </section>

                            <!--Message Box - Primary-->

                            <section class="section message-box primary">

                                <div class="message-box-content">
                                    <div class="content-form">
                                        <div class="form-group">
                                            <div class="form-input">
                                                <span class="input">
                                                    <input
                                                        type="search"
                                                        v-model="hasMessage"
                                                        class="form-control"
                                                        placeholder="Escreva a tarefa que precisa ser feita"
                                                        @keyup.enter="getResponseRunIa"
                                                    />
                                                </span>
                                                <span class="button">
                                                    <button
                                                        type="button"
                                                        class="btn btn-block btn-form"
                                                        @click="getResponseRunIa"
                                                        :disabled="!hasMessage || showLoading"
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                        >
                                                            <path
                                                                fill-rule="evenodd"
                                                                clip-rule="evenodd"
                                                                d="M4.79495 5.12264C3.06804 4.50448 1.48934 6.34298 2.36147 7.95659L4.91684 12.6845L2.45796 16.9331C1.53522 18.5274 3.07596 20.4157 4.82302 19.8317L20.5763 14.5658C22.3773 13.9637 22.4041 11.4259 20.6163 10.7859L4.79495 5.12264ZM17.2389 11.7012L4.12092 7.00564L6.65881 11.7012H17.2389ZM6.63923 13.7012L4.18895 17.9349L16.854 13.7012H6.63923Z"
                                                                fill="white"
                                                            />
                                                        </svg>
                                                    </button>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="content-caption">
                                        <div class="caption">
                                            <span>
                                                Lembre-se de sempre revisar! Os
                                                textos são gerados por
                                                inteligência artificial e podem
                                                conter informações imprecisas.
                                               
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PrimarySidebar from '@/components/primarySidebar.vue';
    import parameters from '@/utils/parameters.js';
    import { mapState, mapActions } from 'vuex';
    import crews from '@/utils/crews';
    import users from '@/utils/users';
    import ModalGeneric from '@/components/modals/modalGeneric.vue';
    import ModalUser from '@/components/modals/modalUser.vue';
    import Toolbar from '@/components/toolbarHeader.vue';
    import order from '@/utils/order';

    export default {
        components: {
            PrimarySidebar,
            ModalGeneric,
            ModalUser,
            Toolbar
        },
        data() {
            return {
                hasMessage: '',
                menssageCrew: '',
                crews: [],
                userData: {
                    name: '',
                    email: '',
                    password: ''
                },
                parameters: [],
                responseRunIa: [],
                chatContainer: null,
                submitedMessage: false,
                historyMessages: [],
                showLoading: false
            };
        },
        computed: {
            ...mapState(['token', 'user', 'currentCrew', 'currentRunIa', 'userInfoData'])
        },
        mounted() {
            this.getCrews();
            this.getUserData();
        },
        updated() {
            this.scrollToBottom();
        },
        watch: {
            hasMessage() {
                this.$nextTick(() => {
                    this.scrollToBottom();
                });
            },
            responseRunIa: {
                handler() {
                    this.$nextTick(() => {
                        this.scrollToBottom();
                    });
                },
                deep: true
            }
        },
        methods: {
            ...mapActions(['getCrews', 'storeIsVisibleSideBarGenericModal', 'storeFieldsModalGeneric', 'storeCurrentCrew', 'storeUserInfoData', 'storeIsVisibleModalUser', 'storeCrewsList']),
            async getCrews() {
                try {
                    const response = await crews.getCrews(this.token);
                    this.crews = response;
                    this.storeCrewsList({ crewsList: response });
                } catch (error) {
                    console.error('Erro ao buscar tripulantes:', error);
                }
            },
            async getUserData() {
                try {
                    const response = await users.getUsersById(this.token, this.user.user_id);
                    this.storeUserInfoData({ userInfoData: response });
                } catch (error) {
                    console.error('Erro ao buscar usuário:', error);
                }
            },
            async getParameters(id, crew) {
                try {
                    const response = await parameters.getParameters(this.token, id);
                    this.storeIsVisibleSideBarGenericModal({ isVisibleSideBarGenericModal: true });
                    this.storeFieldsModalGeneric({ fields: response });
                    this.storeCurrentCrew({ currentCrew: crew });
                    this.parameters = response;
                } catch (error) {
                    console.error('Erro ao buscar parâmetros:', error);
                }
            },
            logout() {
                this.storeToken({ token: null });
                this.storeRefreshToken({ refreshToken: null });
                this.$router.push('/login');
            },
            openModalUser() {
                this.storeIsVisibleModalUser({ isVisibleModalUser: true });
            },
            async getResponseRunIa() {
                if (!this.hasMessage || this.showLoading) return;
                
                this.historyMessages.push({
                    content: this.hasMessage
                });
                const currentMessage = this.hasMessage;
                this.hasMessage = '';
                this.submitedMessage = true;
                this.showLoading = true;
                
                const payload = {
                    "id": 0,
                    "type_engine":  1,
                    "crew_id": this.user.crew_id,
                    "request_type": 1,
                    "status": 0,
                    "parameters": [
                        {
                            "type": 1,
                            "property": "request",
                            "value": currentMessage
                        }
                    ]
                };
                try {
                    const response = await order.order(payload, this.token);
                    if (response?.output) {
                        response.output = response.output
                            .replace(/^# (.*$)/gm, '<h1>$1</h1>')
                            .replace(/^## (.*$)/gm, '<h2>$1</h2>')
                            .replace(/^### (.*$)/gm, '<h3>$1</h3>')
                            .replace(/^#### (.*$)/gm, '<h4>$1</h4>')
                            .replace(/^##### (.*$)/gm, '<h5>$1</h5>')
                            .replace(/^###### (.*$)/gm, '<h6>$1</h6>')
                            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                            .replace(/\*(.*?)\*/g, '<em>$1</em>')
                            .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>')
                            .replace(/`([^`]+)`/g, '<code>$1</code>')
                            .replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>')
                            .replace(/^> (.*$)/gm, '<blockquote>$1</blockquote>')
                            .replace(/^- (.*$)/gm, '<li>$1</li>')
                            .replace(/\n/g, '<br> ');
                    }
                    this.responseRunIa.push(response);
                
                    this.showLoading = false;
                    this.$nextTick(() => {
                        this.scrollToBottom();
                    });
                } catch (error) {
                    console.error('Erro ao buscar resposta da IA:', error);
                    this.showLoading = false;
                }
            },
            scrollToBottom() {
                const messageList = this.$refs.messageList;
                if (messageList) {
                    messageList.scrollTop = messageList.scrollHeight;
                }
            }
        }
    }
</script>

<style lang="scss" scoped></style>
<style>
.section.page-body.primary.special {
        overflow: hidden;
    }
</style>
<style scoped>
.loading-dots {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

.loading-dots-content {
    display: flex;
    gap: 8px;
}

.dot {
    width: 8px;
    height: 8px;
    background-color: #4FCCEA;
    border-radius: 50%;
    animation: fade 1.5s infinite;
}

.dot:nth-child(2) {
    animation-delay: 0.5s;
}

.dot:nth-child(3) {
    animation-delay: 1s;
}

@keyframes fade {
    0%, 100% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
}

.value-text p {
    color: white;
}

.message-list {
    height: calc(100vh - 200px);
    overflow-y: auto;
    display: flex;
    flex-direction: column;
}

.message-list::-webkit-scrollbar {
    width: 8px;
}

.message-list::-webkit-scrollbar-track {
    background: transparent;
}

.message-list::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
}

.message-list::-webkit-scrollbar-thumb:hover {
    background: #555;
}
.content-icon {
    display: flex;
    gap: 10px;
    align-items: baseline;
}
.icon img {
    width: 30px;
}
.value-text .title h3 {
    color: white;
    font-size: 16px;
}
.wrapper-inner.asking .desc {
    width: 50%;
    /* display: flex
; */
    /* justify-content: end; */
    background-color: #2f2f2f;
    padding: 15px;
    border-radius: 10px 10px 0px 10px;
    margin-left: 10px;
}
.content-text {
    display: flex;
    justify-content: end;
    margin-right: 10px;
}
.desc p {
    color: white;
    margin-bottom: 0px;
}
.wrapper-inner.asking {
    margin-top: 20px;
}
a.content-anchor {
    cursor: pointer;
}
</style>